import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

export type FlowParticipant = {
  type: "user" | "group"
  id: string
  name?: string
  role: "runner" | "editor"
}

export function useShareWorkflow(workflowId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (
      participants: FlowParticipant[]
    ): Promise<{ participants: FlowParticipant[] }> => {
      return (await api.post(`/explorer/workflow/${workflowId}/share`, {
        participants,
      })) as unknown as { participants: FlowParticipant[] }
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.workflows })
    },
  })
}
